import React from "react"
import Subscribe from "../components/pages/subscribe"

const SubscribePage = (props) => <Subscribe {...props} />

export default SubscribePage